import { Controller } from "@hotwired/stimulus"

const HIDE_DELAY = 350

export default class extends Controller {
  static values = {
    searchLimit: Boolean,
    verifyLimit: Boolean
  }
  static targets = ["indicator"]

  connect() {
    this._showTimer = null
    this._hideTimer = null
    
    // Initialize based on current values
    if (this.searchLimitValue || this.verifyLimitValue) {
      this._forceShow()
    } else {
      this._forceHide()
    }
  }

  disconnect() {
    this._clearTimers()
  }

  searchLimitValueChanged() {
    this.updateVisibility()
  }

  verifyLimitValueChanged() {
    this.updateVisibility()
  }

  updateVisibility() {
    const shouldShow = this.searchLimitValue || this.verifyLimitValue

    // Update the credit-indicator count value to trigger its animations
    if (this.element.dataset.creditIndicatorCountValue !== undefined) {
      this.element.dataset.creditIndicatorCountValue = shouldShow ? "1" : "0"
      
      // Dispatch event to notify credit-indicator controller of the change
      this.element.dispatchEvent(new CustomEvent("credit-indicator:count-changed", {
        detail: { count: shouldShow ? 1 : 0 }
      }))
    }

    if (shouldShow) {
      this.show()
    } else {
      this.hide()
    }
  }

  show() {
    if (this.element.classList.contains("is-visible")) return

    this._clearTimers()
    this.element.classList.remove("hidden")

    this._showTimer = setTimeout(() => {
      this.element.classList.add("is-visible")
      this._showTimer = null
    }, 0)
  }

  hide() {
    if (this.element.classList.contains("hidden")) return

    this._clearTimers()
    this.element.classList.remove("is-visible")

    this._hideTimer = setTimeout(() => {
      this.element.classList.add("hidden")
      this._hideTimer = null
    }, HIDE_DELAY)
  }

  _forceShow() {
    this._clearTimers()
    this.element.classList.remove("hidden")
    this.element.classList.add("is-visible")
  }

  _forceHide() {
    this._clearTimers()
    this.element.classList.remove("is-visible")
    this.element.classList.add("hidden")
  }

  _clearTimers() {
    if (this._showTimer) { clearTimeout(this._showTimer); this._showTimer = null }
    if (this._hideTimer) { clearTimeout(this._hideTimer); this._hideTimer = null }
  }

  checkLimits(searchNeeded, verifyNeeded, searchAvailable, verifyAvailable, isSingleBucket = false) {
    if (isSingleBucket) {
      // For single bucket, compare total needed against the single bucket
      const totalNeeded = searchNeeded + verifyNeeded
      const limitExceeded = totalNeeded > searchAvailable
      console.log('[LimitReached] Single bucket - Total needed:', totalNeeded, 'Available:', searchAvailable, 'Exceeded:', limitExceeded)
      this.searchLimitValue = limitExceeded
      this.verifyLimitValue = false // Don't set both for single bucket
    } else {
      // For dual bucket, compare each type separately
      this.searchLimitValue = searchNeeded > searchAvailable
      this.verifyLimitValue = verifyNeeded > verifyAvailable
      console.log('[LimitReached] Dual bucket - Limits exceeded - Search:', this.searchLimitValue, 'Verify:', this.verifyLimitValue)
    }
  }
}
